import React from "react";
import { v4 as uuidv4 } from 'uuid';
import EventEmitter from 'eventemitter3';
import { matchPath } from "react-router";
import { Tooltip } from 'react-bootstrap';
import Locale from "../locale/Locale";
const AppContext = React.createContext();

class RpcError extends Error {
    constructor(message, code) {
        super(message);
        this.message = message;
        this.code = code;
    }
}

let setByStateTexts = {
    LOCAL_UI: Locale.gettext("Local UI"),
    FREEZE_PROTECT: Locale.gettext("Freeze Protect"),
    SCHEDULE: Locale.gettext("Schedule"),
    MONITOR: Locale.gettext('Monitor'),
    READYBY_SCHEDULE: Locale.gettext('Schedule'),
    API: Locale.gettext('API'),
    BUTTON : Locale.gettext('Button'),
};

class PoolsideContext extends EventEmitter {
    pathPrefix = process.env.NODE_ENV === "development" ? "" : "";
   // apiUrl = process.env.NODE_ENV === "development" ? "/api/jsonrpc/v1" : "https://api-dev.poolside.tech/api/jsonrpc/v1";
    //wsUrl = process.env.NODE_ENV === "development" ? "ws://localhost:3000/websocket" : "wss://api-dev.poolside.tech/websocket";
    //apiUrl = process.env.NODE_ENV === "development" ? "https://api-dev.poolside.tech/api/jsonrpc/v1" : "https://api-dev.poolside.tech/api/jsonrpc/v1";
    //wsUrl = process.env.NODE_ENV === "development" ? "wss://api-dev.poolside.tech/websocket" : "wss://api-dev.poolside.tech/websocket";
    
    realms = { 
        'Prod': {
            name: 'Prod',
            apiUrl: "https://admin-api.poolside.cloud/api/jsonrpc/v1",
            wsUrl: "wss://admin-api.poolside.cloud/websocket"
        },
        'Dev': { 
            name: 'Dev',
            apiUrl: "https://admin-api-dev.poolside.cloud/api/jsonrpc/v1",
            wsUrl: "wss://admin-api-dev.poolside.cloud/websocket"
        }
    };
    apiUrl = this.realms[window.localStorage.realm]?.apiUrl || "https://admin-api-dev.poolside.cloud/api/jsonrpc/v1";
    wsUrl = this.realms[window.localStorage.realm]?.wsUrl || "wss://admin-api-dev.poolside.cloud/websocket";

    accessToken = window.localStorage.accessTokenSwitch || window.localStorage.accessToken || null;
    userInfo = null;
    webSocket;
    
    wsIncomingRequestHandlers = {
        "Connection.requestAuth": this.wsAuthRquested.bind(this),
        "Connection.activate": this.wsActivated.bind(this),
        "Gateway.updateConnections": this.connectionsUpdated.bind(this),
        "Gateway.tunnelData": this.tunnelData.bind(this),
        "Site.setStates": (packet) => {
            this.emit("updateStates", packet);
        }
    };
    wsOutgoingRequestHandlers = {};
    gatewayConnections = [];
    tunnelHandlers = {};
    versions = [];

    constructor() {
        super();
        if (process.env.NODE_ENV === "development") {
            this.realms['Local'] = { 
                name: 'Local',
                apiUrl: "http://localhost:8080/api/jsonrpc/v1",
                wsUrl: "ws://localhost:3000/websocket"
            };
        }
        this.apiUrl = this.realms[window.localStorage.realm]?.apiUrl || "https://api-dev.poolside.cloud/api/jsonrpc/v1";
        this.wsUrl = this.realms[window.localStorage.realm]?.wsUrl || "wss://api-dev.poolside.cloud/websocket";
        if (!this.userInfo) {
            this.getUserInfo()
                .catch(err => console.error("Could not get user info:", err));
        }
    }

    abortAllOutgoingRequestHandlers(error) {
        Object.values(this.wsOutgoingRequestHandlers).forEach(handler => {
            handler({
                error
            });
        });
    }

    async getUserInfo() {
        if (this.accessToken) {
            let response = await this.makeRequest("User.getInfo", {});
            if (response.result) {
                this.userInfo = response.result;
                Locale.setLocaleInfo({
                    dateFormat: this.dateFormat,
                    locale: this.userInfo?.language,
                    temperatureType: this.userInfo?.tempType,
                    timeHours: this.timeHours,
                    // timezone: 'America/New_York'
                });
            } else if (response.error) {
                this.logout();
            }
            this.emit("navigate");
            return response.result;
        }
    }

    async login(creds) {
        creds.realm = "Prod";
        if (creds.realm && this.realms[creds.realm]) {
            let rlm = this.realms[creds.realm];
            this.apiUrl = rlm.apiUrl;
            this.wsUrl = rlm.wsUrl;
        }

        let response = await this.makeRequest("User.login", creds);

        if (response.error) {
            if (response.error.code !== 407)
                alert("Authentication Failed!");
            
            return response.error;
        } else {
            this.accessToken = response.result.accessToken;
            this.refreshToken = response.result.refreshToken;
            let userInfo = await this.getUserInfo();
            if (userInfo.organizations.length === 0 && userInfo.admin !== true) {
                this.accessToken = null;
                this.refreshToken = null;
                alert("Access denied!");
                return false;
            }
            window.localStorage.realm = creds.realm;
            window.localStorage.accessToken = response.result.accessToken;
            window.localStorage.refreshToken = response.result.refreshToken;
            //contextInstance.updateVersions();
            contextInstance.getUserInfo();
            return true;
        }
    }

    async logout() {
        this.accessToken = null;
        delete window.localStorage.accessToken;
        delete window.localStorage.refreshToken;
        delete window.localStorage.accessTokenSwitch;
        delete window.localStorage.refreshTokenSwitch;
        document.location.reload();
    }

    async impersonate(email) {
        let response = await this.makeRequest('Admin.getAccessToken', {
            email: email
        });
        if (response.result?.accessToken) {
            window.localStorage.accessTokenSwitch = response.result.accessToken;
            window.localStorage.refreshTokenSwitch = response.result.refreshToken;
            this.accessToken = response.result.accessToken;
            this.refreshToken = response.result.refreshToken;
            return true;
        }
        return false;
    }

    unpersonate() {
        delete window.localStorage.accessTokenSwitch;
        delete window.localStorage.refreshTokenSwitch;
    }

    async refresh(creds) {
        console.log("Refreshing access token.");
        this.accessToken = window.localStorage.refreshTokenSwitch || window.localStorage.refreshToken;
        let response = await this.makeRequest("User.refreshToken", creds);

        if (response.error) {
            console.log("Refreshing access token failed", response.error);
            return false;
        } else {
            console.log("Refreshing access token successful!");
            window.localStorage.accessToken = response.result.accessToken;
            this.accessToken = window.localStorage.accessToken;
            this.refreshToken = window.localStorage.refreshToken;

            return true;
        }
    }

    async makeRequest(method, params) {
        if (this.webSocket?.readyState === 1) {
            // TODO: Re-enable when server is updated
            //return this.makeWsRequest(method, params);
        }
        const body = this.getRequest(method, params, false);
        const requestOptions = {
            //mode: 'no-cors',
            method: 'POST',
            headers: { 
                'Content-Type': 'application/json',
                'Authorization': this.accessToken ? "Bearer " + this.accessToken : "None"
            },
            body: JSON.stringify(body)
        };

        console.debug(`[http] ----> ${body.method}, ${body.id}`, body.params);
        //console.log(this.apiUrl, requestOptions);
        const response = await fetch(this.apiUrl, requestOptions);
        //console.log(response.ok, response.status);
        if (!response.ok) {
            if ((response.status === 401 || response.status === 403) && window.localStorage.refreshToken) {
                await this.refresh();
            } else {
                throw new RpcError("Invalid HTTP status " + response.status, response.status);
            }
        }

        const responseDecoded = await response.json();
        console.debug(`[http] <---- ${body.method}, ${body.id}`, responseDecoded?.result, responseDecoded?.error);

        return responseDecoded;
    }

    getRequest(method, params, stringify = true) {
        let req = { 
            id: uuidv4(),
            jsonrpc: "2.0",
            method,
            params
        };
        return stringify ? JSON.stringify(req) : req;
    }

    async getConnections() {
        try {
            this.gatewayConnections = (await this.makeWsRequest("Gateway.getConnections", {})).result;
        } catch (e) {

        }
        this.emit("updateConnections", this.gatewayConnections);

        return this.gatewayConnections;
    }

    isConnected(uuid) {
        if (!Array.isArray(this.gatewayConnections)) {
            return false;
        }
        let match = this.gatewayConnections.find((item) => item.clientInfo.uuid === uuid );

        return typeof match === "undefined" ? false : match;
    }

    async makeWsRequest(method, params) {
        return new Promise((resolve, reject) => {
            if (this.webSocket.readyState !== 1) {
                reject(new Error("Connection not active"));
            }
            let request = this.getRequest(method, params, false);
            this.wsOutgoingRequestHandlers[request.id] = response => {
                const idToLog = "id: " + (response.id ?? "-") + (
                    response.id !== request.id ?
                        " reqId: " + request.id :
                        ""
                );
                const traceIdToLog = "traceId: " + (response.traceId ?? "-") + (
                    response.traceId !== request.traceId ?
                        " reqTraceId: " + request.traceId :
                        ""
                );
                
                console.debug("[WS] <-rs-", request.method, idToLog, traceIdToLog, request.params);
                if (response?.result) {
                    resolve(response)
                } else {
                    reject(response?.error)
                }
            };
            console.debug("[WS] -rq->", request.method, request.id, request.params)
            this.webSocket.send(JSON.stringify(request));
        });
    }
    async connectWebsocket() {
        if (this.webSocket) {
            return;
        }
        document.cookie = 'X-Authorization=' + this.accessToken + '; path=/';
        this.webSocket = new WebSocket(this.wsUrl, null, {
            "headers": {
              "Authorization": "Bearer " + this.accessToken
            }
        });
        this.webSocket.onopen = () => {
            console.log("Websocket connected.");
        };
        this.webSocket.onmessage = this.handleWebsocketMessage.bind(this);
        this.webSocket.onclose = (event) => {
            console.log("Websocket closed with code:", event?.code ?? '-', "reason:", event?.reason || '-', "Was clean:", event?.wasClean ?? '-', );
            this.abortAllOutgoingRequestHandlers({
                message: "Websocket closed"
                    + (typeof event?.code === "undefined" ? "" : " with code: " + event.code)
                    + (event?.reason ? " with reason: " + event.reason : "")
                    + (typeof event?.wasClean === "undefined" ? "" : " was clean: " + event.wasClean)
                ,
                code: event?.code
            });
            setTimeout(() => this.connectWebsocket(), 3000);
            this.webSocket = null;
        };
    }
    wsAuthRquested(message) {
        console.log("Server requested to authenticate.");
        this.makeWsRequest("Connection.Authenticate", this.accessToken)
            .catch((e) => {
                console.error("Auth error:", e);
            });
    }
    wsActivated(message) {
        console.log("Websocket activated. CONNID: " + message.connectionId);
        this.makeWsRequest("Gateway.registerMonitor")
            .catch((e) => {
                console.log("registerMonitor error " + e.message);
            });
        this.getConnections();
    }

    handleWebsocketMessage(message) {
        let packet = JSON.parse(message.data);
        if (typeof this.wsOutgoingRequestHandlers[packet.id] !== "undefined") {
            this.wsOutgoingRequestHandlers[packet.id](packet);
            delete this.wsOutgoingRequestHandlers[packet.id];
        } else if (typeof this.wsIncomingRequestHandlers[packet.method] !== "undefined") {
            console.debug("[WS] <-rq-", packet.method, packet.id, packet.traceId ?? "-", packet.params)
            this.wsIncomingRequestHandlers[packet.method](packet.params);
        } else {
            console.debug("[WS] <-??-", packet.method, packet.id, packet.traceId ?? "-", packet.params)
        }
    }

    navigate(path, title) {
        //window.history.pushState(this.pathPrefix + path, title, this.pathPrefix + path);
        document.location = (path[0] !== "#" ? "#" : "") + path;
        this.emit("navigate");
    }

    connectionsUpdated(list) {
        console.log("Gateway.updateConnections", list);
        this.gatewayConnections = list;
        this.emit("updateConnections", list);
    }

    tunnelData(params) {
        if (this.tunnelHandlers[params.tunnelId]) {
            this.tunnelHandlers[params.tunnelId](params.data);
        }
    }

    async createTunnel(connectionId, tunnelId, handler) {
        this.tunnelHandlers[tunnelId] = handler;

        return await this.makeWsRequest("Gateway.createTunnel", {
            tunnelId: tunnelId,
            connectionId: connectionId,
            type: "bash"
        })
    }

    async closeTunnel(tunnelId) {
        delete this.tunnelHandlers[tunnelId];

        return await this.makeWsRequest("Gateway.closeTunnel", {
            tunnelId: tunnelId
        })
    }

    getQueryParams() {
        let params = {};
        let hashParts = document.location.hash.split("?");
        let paramQ = hashParts[1] || "";
        paramQ.split("&")
            .forEach((item) => {
                let tmp = item.split("=");
                if (tmp.length >= 2)
                    params[tmp[0]] = decodeURIComponent(tmp[1]);
            });
        return params;
    }
    matchPath(pathPrefix) {
        let hash = document.location.hash.split("?")[0];
        let match = matchPath(hash.replace("#", ""), {
            path: this.pathPrefix + pathPrefix + "/:recordId?/:tab?/:subTab?",
            exact: true,
            strict: false
        });
        /*if (match.params.length > 0) {
            match = matchPath(document.location.hash.replace("#", ""), {
                path: this.pathPrefix + pathPrefix + "/:recordId?",
                exact: true,
                strict: false
            })
        }
        if (match.params.length > 0) {
            match = matchPath(document.location.hash.replace("#", ""), {
                path: this.pathPrefix + pathPrefix,
                exact: true,
                strict: false
            })
        }*/
        return match;
    }
    
    subGet(source, name) {
        if (!source) {
            return undefined;
        }
        let nameParts = name.split('.');
        if (nameParts.length > 1) {
            let currLevelName = nameParts.shift();
            if (typeof source[currLevelName] === 'undefined' || source === null) {
                return undefined;
            }
            return this.subGet(source[currLevelName], nameParts.join('.'));
        }
        return source[name];
    }
    subSet(source, name, value) {
        let nameParts = name.split('.');
        if (nameParts.length > 1) {
            let currLevelName = nameParts.shift();
            if (Array.isArray(source[currLevelName]) && source[currLevelName].length === 0) {
                delete source[currLevelName];
            }

            if (typeof source[currLevelName] === 'undefined' || source[currLevelName] === null) {
                source[currLevelName] = {};
            }
            return this.subSet(source[currLevelName], nameParts.join('.'), value);
        }
        if (source) {
            source[name] = value;
        } else {
            console.log('Tying to set member of invalid value:', source, name, value);
        }
    }

    async updateVersions() {
        try {
            let list = await this.makeRequest("Admin.getVersions", {});
            this.versions = list.result;
            this.versions.sort((verA, verB) => {
                let verAParts = verA.Version.split('.');
                let verBParts = verB.Version.split('.');
                for (let i = 0; i < Math.max(verAParts.length, verBParts.length); i++) {
                    if (Number(verBParts[i] || 0) - Number(verAParts[i] || 0) !== 0) {
                        return Number(verBParts[i] || 0) - Number(verAParts[i] || 0);
                    }
                }
                return 0;
            });
        } catch (e) {
            setTimeout(() => {
                this.updateVersions();
            }, 2000);
        }
    }
    resolveVersion(verHash) {
        if (verHash && typeof verHash === "object")
            verHash = verHash.state;
        if (!verHash)
            return null;
        return this.versions?.find(ver => ver.VersionHash.trim().toLowerCase() === verHash.trim().toLowerCase());
    }

    getAwayModeStatus(itemStates, deviceUuid, siteUuid) {
        let schedulerVersion = itemStates?.find(st => st.item === siteUuid && st.name === "SchedulerVersion")?.state;
        let deviceAway = itemStates?.find(st => st.item === deviceUuid && st.name === "AwayMode" )?.state;
        let siteAway = itemStates?.find(st => st.item === siteUuid && st.name === "AwayMode" )?.state;

        if (deviceAway) {
            try {
                deviceAway = JSON.parse(deviceAway);
            } catch {
                deviceAway = null;
            }
        }
        
        if (siteAway) {
            try {
                siteAway = JSON.parse(siteAway);
            } catch {
                siteAway = null;
            }
        }

        let awayState = deviceAway || siteAway || {};
        
        if (schedulerVersion && Number(schedulerVersion) >= 2) {
            let status = awayState ?? {};
    
            status.Scheduled = status.Settings?.On && new Date(status.Settings?.From) > new Date();
            status.StatusText = status.AwayModeOn ? "Away" : (
                status.Settings?.On && new Date(status.Settings?.From) > new Date() ? "Scheduled" : "Off"
            );
    
            return status;
        }
        
        return {
            StatusText: awayState === "ON" ? 'Away' : "Off",
            AwayModeOn: awayState === "ON",
            Scheduled: false,
            Settings: {}
        };
    }
    
    renderTooltip(text, props) {
        return (
            <Tooltip id="tooltip" {...props}>
              { text }
            </Tooltip>
        );
    }
    
    getUpcomingEventPerformerName(config, eventInfo, unknownText = null) {
        let src = eventInfo?.SetByState || eventInfo?.Source;
        let srcName = eventInfo?.UserName || eventInfo?.SourceName;
        let text = setByStateTexts[eventInfo?.SetByState || eventInfo?.Source];
        if (text) 
            return text;
        let isController = config.Controllers?.find(ct => ct.UUID === src);
        if (isController) {
            return Locale.gettext('Local');
        }
        return src === this.userInfo.uuid ? Locale.gettext('You') : (
                    srcName ? srcName : 
                        unknownText || Locale.gettext('Someone else')
                );
    }
    
    convertTemp = function(fahrenheitTemp, precision = 1) {
        if (isNaN(fahrenheitTemp) || fahrenheitTemp === null || typeof fahrenheitTemp === 'boolean') return fahrenheitTemp;
    
        let temp = fahrenheitTemp;
        if (this.userInfo?.tempType?.toLowerCase() === 'c') {
            temp = (fahrenheitTemp - 32) / 1.8;
        }
        return Math.round(temp * Math.pow(10, precision) ) / Math.pow(10, precision);
    }

    deConvertTemp = function(userTemp) {
        if (this.userInfo?.tempType?.toLowerCase() === 'c') {
            userTemp = Math.round(userTemp * 1.8 + 32);
        }
        return userTemp;
    }

    safeJsonParse(input, logFail = true) {
        const type = typeof input;
        try {
            return JSON.parse(input);
        } catch (err) {
            if (logFail) {
                if (type === 'undefined') {
                    console.warn('safeJsonParse() Undefined is not a valid JSON:', err);
                } else {
                    console.error('safeJsonParse() Could not parese as JSON:', input, `type: ${type}, error:`, err);
                }
            }
        }
    }

    getMobileMock(allConfigs) {
        let getCurrentConfig = function(fileName = "Config.json") {
            return { fileName: fileName, data: allConfigs[fileName.replace('.json', '')] };
        }
        let siteConfig = getCurrentConfig();
        return {
            convertTemp: this.convertTemp.bind(this),
            deConvertTemp: this.convertTemp.bind(this),
            getAwayModeStatus: this.getAwayModeStatus.bind(this),
            getUpcomingEventPerformerName: (eventInfo, unknownText) => {
                return this.getUpcomingEventPerformerName(siteConfig, eventInfo, unknownText);
            },
            getControlByUuid: function(uuid, config) {
                config = config || getCurrentConfig();
                return config.data.Controls.find(ctrl => ctrl.UUID === uuid) ||
                            (config.data.CombinedControls || []).find(ctrl => ctrl.UUID === uuid);
            },
            getCurrentConfig: getCurrentConfig
        };
    }

    /**
     * @param {{time: string, level: string, message: string}[]} logs 
     */
    async uploadLogs(logs) {
        const param = logs.map(item => Object.assign(item, {
            locale: Locale.getLocale(),
            platform: window.navigator.userAgent,
        }));
        const res = await this.makeRequest('User.addLogs', param);
        return res;
    }

    /**
     * @param {string} level E.g: "debug", "info", "warn", "error"
     * @param {string} message 
     * @returns
     */
    async uploadLog(level, message) {
        let res;
        try {
            res = this.uploadLogs([ {
                time: (new Date()).toISOString(),
                level,
                message
            } ]);
        } catch (err) {
            console.error(err);
        }
    }
}

const contextInstance = new PoolsideContext();
// Provides easy access from the browser consolefor debugging purpose
window.contextInstance = contextInstance;

if (window.localStorage.accessToken) {
    //contextInstance.updateVersions();
    contextInstance.connectWebsocket();
    contextInstance
        .makeRequest("Api.getVersion", {})
        .then((resp) => {
            contextInstance.apiVerion = resp.result;
        }).catch(e => {
            
        });
}


window.onpopstate = () => {
    //console.log("onpopstate");
    contextInstance.emit("navigate");
}

const AppContextProvider = (props) => {
    return (
       <AppContext.Provider value = {contextInstance}>
          {props.children}
       </AppContext.Provider>
    );
 };
  
export { AppContext, AppContextProvider, contextInstance as context };
